<template>
    <div class="viewInsure">
        <div class="title">
            <p></p>
            <h4>待客户盖章投保列表</h4>
        </div>
        <avue-crud :data="data" :option="option" >
            <template slot="menu" slot-scope="scope" >
                <a :href="scope.row.all_url" target="_blank" style="color: #ffffff"><el-button type="primary">查看文件</el-button></a>
            </template>
        </avue-crud>
        <div class="title" style="margin-top: 40px">
            <p></p>
            <h4>客户已盖章投保列表</h4>
        </div>
        <avue-crud :data="sealData" :option="option1" >
            <template slot="menu" slot-scope="scope" >
                <a :href="scope.row.all_url" target="_blank" style="color: #ffffff"><el-button type="primary">查看文件</el-button></a>
            </template>
        </avue-crud>
    </div>
</template>

<script>
    import { viewInsureList } from '../../../api/insure';

    export default {
        name: 'viewInsurePage',
        data() {
            return {
                data: [],  //待客户盖章投保单列表
                sealData:[], //客户已盖章投保单
                option:{
                    stripe:true,
                    addBtn:false,  //新增按钮
                    align:'center',  //文本居中
                    menuAlign:'center', //操作栏居中
                    columnBtn:false,  //列动态显隐按钮
                    refreshBtn:false,  //刷新按钮
                    editBtn:false,  //编辑按钮
                    delBtn:false,  //删除按钮
                    menuWidth:240,  //操作栏宽度设置
                    column:[
                        {
                            label:'文件名称',
                            prop:'name'
                        }, {
                            label:'创建时间',
                            prop:'add_time'
                        }
                    ]
                },
                option1:{
                    stripe:true,
                    addBtn:false,  //新增按钮
                    align:'center',  //文本居中
                    menuAlign:'center', //操作栏居中
                    columnBtn:false,  //列动态显隐按钮
                    refreshBtn:false,  //刷新按钮
                    editBtn:false,  //编辑按钮
                    delBtn:false,  //删除按钮
                    menuWidth:240,  //操作栏宽度设置
                    column:[
                        {
                            label:'文件名称',
                            prop:'name'
                        }, {
                            label:'创建时间',
                            prop:'add_time'
                        }
                    ]
                },
            };
        },
        created() {
            viewInsureList({case_id:this.$route.query.id}).then(res=>{
                if (res.code==200){
                    this.data=res.data.daigaizhang
                    this.sealData=res.data.yigaizhang
                }else {
                    this.$message.error(res.msg)
                }
            })
        }
    };
</script>

<style scoped>
    .viewInsure{
        padding: 30px;
        background-color: #ffffff;
        border-radius: 5px;
    }
    .title{
        display: flex;
        align-items: center;
        color: #3e62f6;
    }
    .title>p{
        width: 5px;
        height: 18px;
        background-color: #3e62f6;
        margin-right: 10px;
    }
</style>
